export default "__VITE_ASSET__ChtSm1u5__"